/**
 * Type-safe feature flag registry per docs/architecture/ARCHITECTURE-V2-ADDENDUM.md (TASK 5).
 * `marketplace` is registered but intentionally always false — reserved per
 * the approved baseline (FINAL-ARCHITECTURE.md), no implementation exists for it.
 */
export const FEATURE_FLAGS = ['gallery', 'investment', 'career', 'blog', 'marketplace'] as const;

export type FeatureFlagName = (typeof FEATURE_FLAGS)[number];

export type FeatureFlagMap = Record<FeatureFlagName, boolean>;

/**
 * Default values used when a flag source provides no explicit value.
 * `marketplace` defaults to false and must never be overridden to true
 * without a corresponding architecture decision (see ADR-007).
 */
export const DEFAULT_FEATURE_FLAGS: FeatureFlagMap = {
  gallery: true,
  investment: true,
  career: true,
  blog: true,
  marketplace: false
};
